module.exports = __webpack_public_path__ + "img/wallet.9a73f10a.svg";